<div [hidden]="!loading" class="loading">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

@if (!loading) {
  <mat-tab-group data-test="identified-criteria-popup" [selectedIndex]="selectedTabIndex" class="criteria-details">
    @if (hasPopular) {
      <mat-tab label="{{ 'visits.criteriaProperties.latest' | translate }} {{ 'visits.criteriaProperties.' + header.trim() | translate }}">
        <div class="tab-content">
          @if (showAny()) {
            <mat-checkbox (change)="onAnyClicked($event)" [checked]="isAnyChecked">
              <i>{{ "operators.Any" | translate }}</i>
            </mat-checkbox>
          }
          @for (item of popularSuggestions; track item) {
            <div>
              <mat-checkbox [name]="item.id" (change)="onPopularClicked($event, item.id)" [(ngModel)]="item.checked">
                <span [matTooltip]="getCleanedHtml(item.displayName)" [innerHtml]="item.displayName"></span>
              </mat-checkbox>
            </div>
          }
          <mat-card-actions fxLayoutAlign="end">
            <button mat-stroked-button class="secondary-button" (click)="cancel()">{{ "generic.cancel" | translate }}</button>
            <button mat-stroked-button class="primary-button" [disabled]="submitIsDisabled()" (click)="close()">{{ "generic.use" | translate }}</button>
          </mat-card-actions>
        </div>
      </mat-tab>
    }
    <mat-tab
      label="{{ (header === 'consent' ? 'generic.given' : getTitle(header)) | translate }} {{ 'visits.criteriaProperties.' + header.trim() | translate }}">
      <div class="tab-content">
        @if (!isOnsiteCampaignDialog) {
          @if (description) {
            <div>{{ description | translate }}</div>
          }
          @if (showOperator == true && header !== "consent" && operators && operators.length > 0) {
            <div>
              <!--do not display operator in custom fields-->
              <mat-form-field>
                <mat-select
                  placeholder="{{ 'generic.choose' | translate }}..."
                  [ngModel]="inputSearchCriteria.operator"
                  (ngModelChange)="operatorChanged($event)">
                  @for (operator of operators; track operator) {
                    <mat-option [value]="operator.value">{{ "operators." + operator.key | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (header === "consent") {
            <div class="radio-wrapper">
              <mat-radio-group [(ngModel)]="consentModel" fxLayout="column" fxLayoutAlign="space-around">
                @for (option of consentOptions; track option) {
                  <mat-radio-button [value]="option">
                    <p>{{ "visits.consentOptions." + option.text | translate }}</p>
                  </mat-radio-button>
                }
                @if (consentModel.value === 1) {
                  <div>
                    @if (suggestions.length > 0) {
                      <app-field-autocomplete
                        [data]="suggestions"
                        [value]="inputSearchCriteria.input"
                        [operator]="inputSearchCriteria.operator"
                        (selectedInput)="addSelectedInput($event)"></app-field-autocomplete>
                    }
                    @if (suggestions.length < 1) {
                      <div class="suggestions-empty">{{ "people.no-policy" | translate }}</div>
                    }
                  </div>
                }
              </mat-radio-group>
            </div>
          }
          @if (showInputFields() && header !== "consent" && !simpleDataForCriteria.length) {
            <div>
              @switch (inputType) {
                @case ("AutoCompleteField") {
                  <div>
                    <app-field-autocomplete
                      [value]="inputSearchCriteria.input"
                      [type]="inputSearchCriteria.type"
                      [operator]="inputSearchCriteria.operator"
                      [widgets]="widgetsSimpleInfo"
                      [data]="suggestions"
                      (selectedInput)="addSelectedInput($event)"></app-field-autocomplete>
                  </div>
                }
                @case ("MultiDropdown") {
                  <div>
                    @if (isCountryFilter) {
                      <app-country-select [value]="inputSearchCriteria.input" (valueChange)="addSelectedInput($event)"></app-country-select>
                    }
                    @if (!isCountryFilter) {
                      <app-field-autocomplete
                        [data]="suggestions"
                        [value]="inputSearchCriteria.input"
                        [operator]="inputSearchCriteria.operator"
                        (selectedInput)="addSelectedInput($event)"
                        [type]="inputSearchCriteria.type"></app-field-autocomplete>
                    }
                  </div>
                }
                @case ("TextField") {
                  <div>
                    @if (inputSearchCriteria.type !== "domain") {
                      <mat-form-field class="text-input">
                        <input
                          matInput
                          placeholder="{{ getTextboxPlaceholderTranslationKey() | translate }}..."
                          [(ngModel)]="inputSearchCriteria.input"
                          (ngModelChange)="validateInput()" />
                      </mat-form-field>
                    }
                    @if (inputSearchCriteria.type === "domain") {
                      <mat-form-field class="text-input">
                        <input
                          matInput
                          placeholder="{{ getTextboxPlaceholderTranslationKey() | translate }}..."
                          [(ngModel)]="inputSearchCriteria.input"
                          (ngModelChange)="validateInput()"
                          (focusout)="stripProtocol(inputSearchCriteria.input); validateInput()" />
                      </mat-form-field>
                    }
                  </div>
                }
                @case ("NumberField") {
                  <div>
                    <mat-form-field>
                      <input matInput placeholder="Add number" type="number" [(ngModel)]="inputSearchCriteria.input" />
                      @if (data.option.name === "siteTime") {
                        <span matSuffix>Sec</span>
                      }
                    </mat-form-field>
                  </div>
                }
                @case ("RadioButtonField") {
                  <div>
                    <app-field-radio
                      [option]="inputSearchCriteria.input"
                      [suggestions]="suggestions"
                      (selectedInput)="addSelectedInput($event)"></app-field-radio>
                  </div>
                }
                @case ("DeviceCustomField") {
                  <div>
                    <app-customfield-device [inputSearchCriteria]="inputSearchCriteria" (addCriteria)="addCriteria($event)"></app-customfield-device>
                  </div>
                }
                @case ("CodeMirror") {
                  <app-code-editor [(value)]="inputSearchCriteria.input" [autoFocus]="true" [height]="codeEditorHeight"></app-code-editor>
                }
                @default {
                  <div>
                    <mat-form-field>
                      <input matInput placeholder="{{ 'generic.typeSomething' | translate }}..." [(ngModel)]="inputSearchCriteria.input" />
                    </mat-form-field>
                  </div>
                }
              }
            </div>
          }
          @if (simpleDataForCriteria.length) {
            <mat-form-field>
              <mat-select placeholder="{{ 'generic.selectList' | translate }}..." (selectionChange)="addSelectedInput($event)">
                @for (item of simpleDataForCriteria; track item) {
                  <mat-option [matTooltip]="item" [value]="item"><span [innerHtml]="item"></span></mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <div [ngClass]="header === 'jsExpression' ? 'jsExpression-hint-wrapper' : 'hint-wrapper'">
            <p [innerHTML]="getUserHint(inputSearchCriteria) | translate"></p>
          </div>
        }
        @if (isOnsiteCampaignDialog) {
          <app-widget-selector-menu
            [items]="widgetsForSelector"
            [multiple]="true"
            [ngModel]="selectedWidgetIds"
            (ngModelChange)="onWidgetSelectionChange($event)"
            [placeholder]="'visits.criteriaProperties.chooseFromList' | translate"></app-widget-selector-menu>
        }
        <mat-card-actions fxLayoutAlign="end">
          <button mat-stroked-button class="secondary-button" (click)="cancel()">{{ "generic.cancel" | translate }}</button>
          <button mat-stroked-button class="primary-button" [disabled]="submitIsDisabled()" (click)="close()">{{ "generic.use" | translate }}</button>
        </mat-card-actions>
      </div>
    </mat-tab>
  </mat-tab-group>
}
